import Vue from 'vue';

export default {
  // 获取媒体报道
  getNewsList(params) {
    return Vue.axios.get('/api/v1.0/system/news/list', {params});
  }
};
